import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import QueryingAnalysisTemplatePage from './AnalysisTemplatePage';
import AnalysisTemplateTabState from './AnalysisTemplateTabState';

export default class AnalysisTemplateTabView extends BufferTabView<AnalysisTemplateTabState> {
  override render(): this {
    const props = {
      analysisTemplateId: this.model.get('analysisTemplateId'),
    };
    renderToDOM(
      <div className="react-tab-container" style={{padding: 0}}>
        <QueryingAnalysisTemplatePage {...props} />
      </div>,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<AnalysisTemplateTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

AnalysisTemplateTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
